import React from 'react';
import { Typography } from 'src/components/PulseUI';
import { Checkbox } from 'src/components';
import { PermissionRowProps } from '../types';
import { createPermissionCode, getScopeDisplayName } from '../utils';

/**
 * Component for rendering a single permission row
 */
const PermissionRow: React.FC<PermissionRowProps> = ({
  resource,
  scope,
  permissions,
  groupApplicableActions,
  selectedPermissions,
  onSelectPermission,
}) => (
  <div
    data-testid={`permission-row-${resource}-${scope}`}
    className="flex items-center px-4 py-2 hover:bg-neutral-50/80 transition-colors group"
  >
    <div className="flex flex-col w-64">
      <Typography className="text-sm text-neutral-700 group-hover:text-neutral-900">
        {getScopeDisplayName(scope)}
      </Typography>
    </div>
    <div className="flex flex-1">
      {groupApplicableActions.map((action) => {
        const permissionCode = createPermissionCode(action, resource, scope);
        const permissionExists = permissions.some(
          (p) => p.code === permissionCode
        );

        return (
          <div
            key={action}
            data-testid={`permission-${resource}-${scope}-${action}`}
            className="flex-1 flex items-center rounded-lg py-1 justify-end pr-4"
          >
            {permissionExists && (
              <Checkbox
                size="sm"
                checked={selectedPermissions.includes(permissionCode)}
                onChange={() => onSelectPermission(permissionCode)}
                data-testid={`permission-checkbox-${permissionCode}`}
              />
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export default PermissionRow;
